/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';
import type { TOTPRegisterChallengeOptions } from './TOTPRegisterChallengeOptions';
import {
    TOTPRegisterChallengeOptionsFromJSON,
    TOTPRegisterChallengeOptionsFromJSONTyped,
    TOTPRegisterChallengeOptionsToJSON,
    TOTPRegisterChallengeOptionsToJSONTyped,
} from './TOTPRegisterChallengeOptions';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface TOTPRegisterChallenge
 */
export interface TOTPRegisterChallenge {
    /**
     * 
     * @type {string}
     * @memberof TOTPRegisterChallenge
     */
    id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof TOTPRegisterChallenge
     */
    type: ChallengeType;
    /**
     * 
     * @type {FactorMethod}
     * @memberof TOTPRegisterChallenge
     */
    authentication_method: FactorMethod;
    /**
     * 
     * @type {TOTPRegisterChallengeOptions}
     * @memberof TOTPRegisterChallenge
     */
    options?: TOTPRegisterChallengeOptions;
}



/**
 * Check if a given object implements the TOTPRegisterChallenge interface.
 */
export function instanceOfTOTPRegisterChallenge(value: object): value is TOTPRegisterChallenge {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('authentication_method' in value) || value['authentication_method'] === undefined) return false;
    return true;
}

export function TOTPRegisterChallengeFromJSON(json: any): TOTPRegisterChallenge {
    return TOTPRegisterChallengeFromJSONTyped(json, false);
}

export function TOTPRegisterChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPRegisterChallenge {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': ChallengeTypeFromJSON(json['type']),
        'authentication_method': FactorMethodFromJSON(json['authentication_method']),
        'options': json['options'] == null ? undefined : TOTPRegisterChallengeOptionsFromJSON(json['options']),
    };
}

export function TOTPRegisterChallengeToJSON(json: any): TOTPRegisterChallenge {
    return TOTPRegisterChallengeToJSONTyped(json, false);
}

export function TOTPRegisterChallengeToJSONTyped(value?: TOTPRegisterChallenge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': ChallengeTypeToJSON(value['type']),
        'authentication_method': FactorMethodToJSON(value['authentication_method']),
        'options': TOTPRegisterChallengeOptionsToJSON(value['options']),
    };
}

